<template>
    <Sheet v-loading="loading.actions['user']">
        <h2>{{routeTitle}}</h2>
        <el-button
                @click="onEnterInsert"
                icon="el-icon-plus"
                size="mini"
                type="primary"
        >
            新增
        </el-button>
        <el-button
                @click="refresh"
                icon="el-icon-refresh"
                size="mini"
        >
            重新整理
        </el-button>

        <el-row
                :gutter="16"
        >
            <el-col :span="14">
                <h4>使用者列表</h4>
                <el-table
                        :data="pagedData"
                        :stripe="true"
                        empty-text="無表單"
                        height="500px"
                        row-key="id"
                        size="small"
                >
                    <el-table-column
                            label="使用者代碼"
                            prop="userId"
                    ></el-table-column>
                    <el-table-column
                            label="名稱"
                            prop="userName"
                    ></el-table-column>
                    <el-table-column
                            label="Email"
                            prop="email"
                    ></el-table-column>
                    <el-table-column
                            label="權限"
                    >
                        <template #default="{row}">
                            {{(roles.find(r => r.id === row.roleId) || {name: ''}).name}}
                        </template>
                    </el-table-column>
                    <el-table-column
                            label="停用?"
                    >
                        <template #default="{row}">
                            {{row.disabled ? '是' : '否'}}
                        </template>
                    </el-table-column>
                    <el-table-column>
                        <template #default="{row}">
                            <el-button
                                    @click="onEnterEdit(row)"
                                    icon="el-icon-edit"
                                    size="mini"
                                    type="primary"
                            ></el-button>
                            <el-button
                                    @click="onRemove(row)"
                                    icon="el-icon-delete"
                                    size="mini"
                                    type="danger"
                            ></el-button>
                        </template>
                    </el-table-column>
                </el-table>
                <el-pagination
                        :current-page.sync="currentPage"
                        :page-size="pageSize"
                        :total="users.length"
                        @current-change="page => pageChange(page, pagedData)"
                        background
                        layout="total, prev, pager, next"
                        style="margin-top: 10px;"
                ></el-pagination>
            </el-col>
            <el-col :span="10" style="background-color: azure">
                <h4>異動</h4>
                <template v-if="current">
                    <el-form
                            :model="current"
                            label-width="100px"
                            ref="form"
                    >
                        <el-form-item
                                :label="isInsertMode ? '使用者' : '使用者代碼'"
                                prop="userId"
                        >
                            <el-input
                                    readonly
                                    v-if="!isInsertMode"
                                    v-model="current.userId"
                            ></el-input>
                            <el-select
                                    :loading="loading.actions['employee']"
                                    :remote-method="getEmployeeSearchFunc"
                                    clearable
                                    filterable
                                    loading-text="查詢中"
                                    no-data-text="無資料"
                                    no-match-text="查無資料"
                                    placeholder="請輸入要加入的承辦人"
                                    remote
                                    style="margin-right: 2px"
                                    v-else
                                    v-model="current.userId"
                                    @change="onSelectUser"
                            >
                                <el-option
                                        :key="e.userId"
                                        :label="`${e.name}(${e.departmentName})`"
                                        :value="e.userId"
                                        v-for="e in filteredEmployees"
                                ></el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item
                                label="姓名"
                                prop="userName"
                                v-if="!isInsertMode"
                        >
                            <el-input
                                    readonly
                                    v-model="current.userName"
                            ></el-input>
                        </el-form-item>
                        <el-form-item
                                :rules="[ {type: 'email', message: '請輸入合格的信箱', trigger: ['blur', 'change']}]"
                                label="Email"
                                prop="email"
                        >
                            <el-input
                                    placeholder="請輸入電子郵件"
                                    ref="email"
                                    v-model="current.email"
                            ></el-input>
                        </el-form-item>
                        <el-form-item
                                label="權限"
                                prop="roleId"
                        >
                            <el-select
                                    placeholder="請選擇權限"
                                    v-model="current.roleId"
                            >
                                <el-option
                                        :key="r.id"
                                        :label="r.name"
                                        :value="r.id"
                                        v-for="r in roles"
                                ></el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item
                                label="是否停用"
                                prop="disabled"
                        >
                            <el-checkbox
                                    v-model="current.disabled"
                            ></el-checkbox>
                        </el-form-item>
                    </el-form>
                    <div style="width: 100%; text-align: right; background-color: azure; padding: 10px 0px">
                        <el-button
                                @click="onSubmit"
                                size="mini"
                                style="margin-right: 5px;"
                                type="primary"
                        >
                            {{isInsertMode ? '加入' : '更新'}}
                        </el-button>
                    </div>
                </template>
            </el-col>
        </el-row>
    </Sheet>
</template>

<script>
    import {mapActions, mapState} from 'vuex';
    import routeTitleMixin from './routeTitleMixin';
    import pagingMixin from '../pagingMixin';
    import debounce from 'debounce';

    export default {
        name: 'UsersManage',
        mixins: [routeTitleMixin, pagingMixin],
        data: () => ({
            current: null,
            isInsertMode: false
        }),
        computed: {
            ...mapState(['loading']),
            ...mapState('role', ['roles']),
            ...mapState('user', ['users']),
            ...mapState('employee', ['employees']),

            getEmployeeSearchFunc() {
                const self = this;
                return debounce(
                    async (value) => {
                        await self.getEmployeesWithKey(value);
                    },
                    200
                )
            },

            filteredEmployees() {
                return this.employees
                    .filter(e => !this.users.some(d => d.userId === e.userId));
            }
        },
        methods: {
            ...mapActions('role', {
                getRoles: 'getRolesAction',
            }),
            ...mapActions('employee', {
                getEmployeesWithKey: 'getEmployeesWithKeyAction'
            }),

            ...mapActions('user', {
                getAll: 'getUsersAction',
                insert: 'addUserAction',
                remove: 'removeUserAction',
                update: 'updateUserAction',
            }),

            reset() {
                this.current = null;
                this.isInsertMode = false;
            },

            async refresh() {
                await this.getAll();
                this.reset();
            },

            onEnterInsert() {
                this.current = {
                    userName: '',
                    email: '',
                    roleId: null,
                    disabled: false
                };
                this.isInsertMode = true;
            },

            onSelectUser(userId){
                this.$set(this.current, 'userName', (this.employees.find(e => e.userId === userId) || {pureName:''}).pureName);
                this.$set(this.current, 'email', (this.employees.find(e => e.userId === userId) || {email:''}).email);
            },

            async onEnterEdit(row) {
                this.current = {...row};
                this.isInsertMode = false;
                const self = this;
                this.$nextTick(() => {
                    const emailIpt = self.$refs['email'];
                    emailIpt.focus();
                });
            },

            async onRemove({id}) {
                try {
                    await this.$confirm('確定要刪除嗎?', {
                        type: 'danger',
                    });
                    const {success} = await this.remove(id);
                    if (success) {
                        this.$message.success('刪除成功');
                    } else {
                        this.$message.warning('刪除失敗，請重試一次');
                    }
                } catch (e) {
                    if (e !== 'cancel') {
                        this.$message({
                            type: 'error',
                            message: '發生錯誤，請重試一次!'
                        });
                    }
                }
                this.reset();
            },

            async onSubmit() {
                const current = this.$refs['form'];
                current.validate(async valid => {
                    if (valid) {
                        const action = this.isInsertMode ? 'insert' : 'update';
                        const {success} = await this[action]({
                            ...this.current
                        });

                        if (success) {
                            this.$message({
                                type: 'success',
                                message: this.isInsertMode ? '新增成功' : '異動成功'
                            });
                        } else {
                            this.$message({
                                type: 'danger',
                                message: '操作失敗，請重試一次'
                            });
                        }
                        this.reset();
                    } else {
                        this.$message({
                            type: 'warning',
                            message: '驗證失敗，請檢查*欄位'
                        });
                    }
                });
            }
        },

        watch: {
            users(current) {
                this.pagedData = this.pageData(current, 1);
                this.currentPage = 1;
            }
        },

        async created() {
            await this.getAll();
            await this.getRoles();
        }
    }
</script>

<style scoped>

</style>